import { cn } from "@/lib/utils";

export type DashboardModelSummaryCardProps = {
  name: string;
  label: string;
  description: string;
  className?: string;
};

/**
 * Dashboard Models summary tile — large title top-left; narrow wrapping label +
 * muted description in a bottom row (Figma dashboard models strip).
 */
export const DashboardModelSummaryCard = ({ name, label, description, className }: DashboardModelSummaryCardProps) => (
  <article
    className={cn("flex min-h-52 flex-col justify-between gap-10 bg-gray-50 px-6 py-6 text-foreground", className)}
  >
    <h3 className="text-4xl font-semibold tracking-tight">{name}</h3>
    <div className="flex items-start gap-4">
      {/* Narrow column so two-word labels wrap like the mockup ("Maximum Capability"). */}
      <p className="w-[8.5rem] shrink-0 text-lg font-semibold leading-snug">{label}</p>
      <p className="min-w-0 flex-1 text-xs leading-snug text-muted-foreground">{description}</p>
    </div>
  </article>
);
